import React, { useEffect } from "react";
import Logo from "../../components/common/Logo";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { sentOtp } from "../../lib/forgetPassword";
import { useState } from "react";
import { loginWithOtp, getStudentDetails } from "../../lib/AuthApi";
import { useAuth } from "../../context/AuthProvider";
import { getSubscriptions } from "../../lib/Subscription"

const LoginWithOtp = () => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [showOtp, setShowOtp] = useState(false);
  const [timer, setTimer] = useState(0);
  const [loading, setLoading] = useState(false);
  const { setUserData } = useAuth();
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  // 🔹 SEND OTP API
  const handleSendOtp = async () => {
    const trimmedEmail = email.trim();

    // ✅ 1. Empty email
    if (!trimmedEmail) {
      toast.error("Email is required");
      return;
    }

    // ✅ 2. Invalid email
    if (!isValidEmail(trimmedEmail)) {
      toast.error("Enter a valid email address");
      return;
    }

    try {
      setLoading(true);

      const res = await sentOtp(trimmedEmail, "LOGIN");
      // ✅ 3. API success
      if (res?.success) {
        setShowOtp(true);
        setTimer(20); // better UX than 20
        toast.success(res?.message || "OTP sent successfully");
      } else {
        toast.error(res?.message || "Failed to send OTP");
      }

    } catch (err) {
      console.error(err);
      toast.error("Unable to send OTP. Please enter a valid email.");
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    const trimmedEmail = email.trim();

    if (!trimmedEmail) {
      toast.error("Email is required");
      return;
    }

    if (!isValidEmail(trimmedEmail)) {
      toast.error("Enter a valid email address");
      return;
    }

    // Clear OTP immediately
    setOtp(Array(6).fill(""));

    // Start timer immediately
    setTimer(30);

    try {
      // Call API in background
      const res = await sentOtp(trimmedEmail, "LOGIN");

      if (res?.success) {
        toast.success("OTP resent successfully");
      } else {
        toast.error(res?.message || "Failed to resend OTP");
      }

    } catch (err) {
      console.error(err);
      toast.error("Unable to resend OTP");
    }
  };

  const handleLogin = async (enteredOtp) => {
    if (!email.trim() || !enteredOtp) {
      setError("Email and OTP required");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const res = await loginWithOtp({
        username: email,
        otp: enteredOtp,
      });

      console.log("Login Response:", res);

      // Check success
      if (!res?.data?.isSuccess) {
        toast.error(res?.data?.displayMessage || "Login failed");
        return;
      }
      const result = res.data.result;

      // Match EXACT API response
      const basicUser = {
        token: result.token,
        userID: result.userID,
        uuid: result.uuid,
        sessionId: result.sessionId,
        role: result.roleName,
      };

      // Save basic user
      localStorage.setItem("user", JSON.stringify(basicUser));
      setUserData(basicUser);

      // ================= STUDENT DETAILS =================
      const studentRes = await getStudentDetails();
      const studentData = studentRes?.data?.[0] || {};

      let finalUserData = {
        ...basicUser,
        ...studentData,
      };

      // ================= SUBSCRIPTION =================
      const subRes = await getSubscriptions(finalUserData.uuid);

      finalUserData = {
        ...finalUserData,
        hasSubscription: subRes?.success || false,
        subscriptionData: subRes?.data || null,
      };

      // ✅ Save final user
      localStorage.setItem("user", JSON.stringify(finalUserData));
      setUserData(finalUserData);

      // ✅ Redirect
      if (subRes?.success) {
        navigate("/live-classes");
      } else {
        navigate("/subscription");
      }

    } catch (err) {
      console.error(err);
      toast.error(
        err.displayMessage || "Invalid OTP"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleOtpChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;

    setOtp(newOtp);

    // move to next input
    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`).focus();
    }

    // auto submit when full
    if (newOtp.every((digit) => digit !== "")) {
      handleLogin(newOtp.join(""));
    }
  };

  useEffect(() => {
    if (timer <= 0) return;

    const interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };
  return (
    <>
      <title>Login With OTP | InstaED</title>

      <main className="h-screen flex items-center justify-center bg-secondary font-sans relative">

        {/* LOGO */}
        <div className="absolute top-5 left-4">
          <Logo />
        </div>

        {/* MAIN WRAPPER */}
        <div className="w-full max-w-md flex items-center justify-center px-6 mx-auto">

          {/* LEFT SIDE - MOBILE OTP */}
          {/* <div className="w-1/2 flex flex-col items-center text-center pr-10">

            <h2 className="text-lg font-semibold mb-6">
              Login via Mobile OTP
            </h2>

            <input
              type="text"
              placeholder="Enter registered mobile number"
              className="w-full h-[50px] px-4 rounded-lg border border-gray-border bg-white placeholder:text-gray-light outline-none mb-6"
            /> */}

          {/* OTP BOXES */}
          {/* <div className="flex gap-3 mb-6">
              {[1, 2, 3, 4].map((_, i) => (
                <input
                  key={i}
                  maxLength={1}
                  className="w-[45px] h-[45px] text-center rounded-lg border border-gray-border bg-white outline-none"
                />
              ))}
            </div> */}

          {/* <p className="text-sm mb-4">
              OTP has been sent to your registered <br />
              mobile number
            </p>

            <p className="text-sm">
              Not received?{" "}
              <span className="underline cursor-pointer">
                Resend
              </span>{" "}
              in: 20 sec
            </p>
          </div> */}

          {/* CENTER DIVIDER */}
          {/* <div className="flex flex-col items-center justify-center">
            <div className="w-[1px] h-[260px] bg-gray-border"></div>
            <span className="absolute bg-secondary px-3 text-sm">or</span>
          </div> */}

          {/* RIGHT SIDE - EMAIL OTP */}
          <div className="w-full flex flex-col items-center text-center">

            <h2 className="text-lg font-semibold mb-6">
              Login via Email OTP
            </h2>

            {!showOtp && (
              <>
                <input
                  type="text"
                  placeholder="Enter registered email ID"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleSendOtp();
                    }
                  }}
                  className="input"
                />
                <div className="flex justify-center mt-4 bg-black-600 text-white px-6 py-2 rounded-lg">
                  <button onClick={handleSendOtp} className="btn">
                    {loading ? "Sending..." : "Send OTP"}
                  </button>
                </div>
              </>
            )}
            {showOtp && (
              <>
                <div className="flex gap-3 mb-6">
                  {[...Array(6)].map((_, i) => (
                    <input
                      key={i}
                      id={`otp-${i}`}
                      maxLength={1}
                      value={otp[i]}
                      onChange={(e) => handleOtpChange(e.target.value, i)}
                      onKeyDown={(e) => handleKeyDown(e, i)}
                      className="w-[45px] h-[45px] text-center rounded-lg border"
                    />
                  ))}
                </div>

                <p className="text-sm mb-4">
                  OTP has been sent to your registered <br />
                  email ID
                </p>

                <p className="text-sm">
                  Not received?{" "}
                  <span
                    className={`underline ${timer !== 0 ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
                      }`}
                    onClick={() => {
                      if (timer === 0) handleResendOtp();
                    }}
                  >
                    Resend
                  </span>{" "}
                  in: {timer} sec
                </p>
              </>
            )}
          </div>
        </div>

        {/* FOOTER */}
        <footer className="absolute bottom-4 text-sm text-gray-border">
          <span>2026</span>
          <span className="mx-3">|</span>
          <button className="hover:opacity-70">
            Terms of Use
          </button>
          <span className="mx-3">|</span>
          <button className="hover:opacity-70">
            Privacy Policy
          </button>
        </footer>

      </main>
    </>
  );
};

export default LoginWithOtp;